/**
 * Runtime configuration from /appsettings.json (copied from public/ at build).
 * Edit public/appsettings.json per client; redeploy or replace the file on the server only.
 */

let cached = null;
let inflight = null;

function appsettingsFetchUrl() {
  const p = process.env.PUBLIC_URL ?? '';
  if (!p || p === '/') return '/appsettings.json';
  const withSlash = p.endsWith('/') ? p : `${p}/`;
  return `${withSlash}appsettings.json`;
}

function normalizeBaseUrl(url) {
  const s = String(url || '').trim();
  if (!s) return '';
  return s.endsWith('/') ? s : `${s}/`;
}

/**
 * Fetches and caches appsettings.json. Call once before rendering the app.
 * @returns {Promise<{ API_BASE_URL: string }>}
 */
export function loadAppSettings() {
  if (cached) return Promise.resolve(cached);
  if (inflight) return inflight;
  inflight = (async () => {
    const res = await fetch(appsettingsFetchUrl(), { cache: 'no-store' });
    if (!res.ok) {
      throw new Error(`Could not load appsettings.json (HTTP ${res.status}). Check public/appsettings.json exists.`);
    }
    const data = await res.json();
    const base = normalizeBaseUrl(data.API_BASE_URL);
    if (!base) {
      throw new Error('appsettings.json must include a non-empty API_BASE_URL.');
    }
    cached = { ...data, API_BASE_URL: base };
    inflight = null;
    return cached;
  })();
  return inflight;
}

export function getAppSettings() {
  if (!cached) {
    throw new Error('App settings not loaded. loadAppSettings() must complete before API calls.');
  }
  return cached;
}

export function getApiBaseUrl() {
  return getAppSettings().API_BASE_URL;
}

export function getManagementApiBaseUrl() {
  const settings = getAppSettings();
  const url = String(settings.MANAGEMENT_API_BASE_URL || settings.MANAGEMENT_API_URL || '').trim();
  if (!url) return '';
  return url.endsWith('/') ? url : `${url}/`;
}
